import React, { createRef, PureComponent } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import Input from '../theme/forms/Input';
import { updateCrewCanvasser } from '../../store/api/calls';
import { connect } from 'react-redux';
import { AvailRoleToken } from './DraggableShiftCanvasser';
import { get as _get } from 'lodash';
import api from '../../store/api/api';
import NoteTagList from '../theme/buttons/NoteTag';
import { setSessionVar } from '../../store/actions';
import UberSiteCrewModal from '../modals/UberSiteCrewModal';
import { allowUber } from '../uber/allowUber';
import UberRideTable from '../uber/UberRideTable';
import { useUberRides } from '../uber/useUberRides';
import UberSubmitErrorModal from '../uber/UberSubmitErrorModal';
import UberRideInfoModal from '../uber/UberRideInfoModal';

class RouteSeatAssigment extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            editingIsDriver: false,
            editingIsDriverValue: false,
            editingRole: false,
            editingRoleValue: null,
            editingGoal: false,
            editingGoalValue: null,
            editingGoalPrevValue: null,
            editingComments: false,
            editingCommentsValue: null,
            editingCommentsPrevValue: null,
            editingAssignmentPlaceholder: null,
            assignmentPlaceholderValue: null,
            loadingRides: false,
            savingRide: false,
        };

        this.goalInputRef = createRef();
        this.commentsInputRef = createRef();
        this.roleSelectRef = createRef();
    }

    componentDidMount() {
        let role = (this.props.seat.roles || []).find((d) => d.name !== 'Driver');
        let isDriver = (this.props.seat.roles || []).map((d) => d.name).includes('Driver');
        this.setState({
            editingGoalValue: this.props.seat.goal,
            editingCommentsValue: this.props.seat.comments,
            editingRoleValue: role ? role.id : null,
            editingIsDriverValue: isDriver,
            assignmentPlaceholderValue: this.props.seat.assignment_placeholder_note,
        });
    }

    _updateParentState = (seat_changes) => {
        let { seat } = this.props;
        seat = { ...seat, ...seat_changes };
        this.props.onCrewCanvasserChange(seat);
    };

    _updateCrewCanvasser = (seat_changes) => {
        return updateCrewCanvasser({
            id: this.props.seat.id || this.props.seat.crewcanvasser_id,
            ...seat_changes,
        });

        if (this.props.refreshUberRides) {
            this.props.refreshUberRides();
        }
    };

    _setAssignmentNote = (data) => {
        api.post('/routeseatassignmentnotes/', data).catch((err) => {
            console.error('failed to update assignment note');
            this.setState({ assignmentPlaceholderValue: null });
        });
    };

    _updateSeat = (seat_changes) => {
        this._updateParentState(seat_changes);
        this._updateCrewCanvasser(seat_changes);
    };

    generateCanvasserDataLine = (canvasser_id) => {
        let c_data = this.props.canvassers.find((d) => d.id === canvasser_id);
        if (!c_data) {
            return (
                <div className="canvasser-meta-grid">
                    <div className="meta-row full-width">
                        <div className="meta-label">Name</div>
                        <div className="meta-value">This canvasser has been deactivated</div>
                    </div>
                    <div className="meta-row full-width">
                        <button
                            className="button button-outline"
                            onClick={() =>
                                this.props.onCanvasserSelect(
                                    canvasser_id,
                                    this.props.seat.routeseat_id,
                                    this.props.seat.crewcanvasser_id,
                                    true
                                )
                            }
                        >
                            Unassign
                        </button>
                    </div>
                </div>
            );
        }

        const _updateCrewCanvasserRole = (val) => {
            if (+val && val !== this.state.editingRoleValue) {
                let roles = [{ id: val }];
                if (this.state.editingRoleValue) {
                    roles.push({ id: this.state.editingRoleValue, delete: true });
                }
                this._updateCrewCanvasser({ roles });

                roles = _get(this.props, 'seat.roles', []).filter((d) => d?.id === 1);

                this._updateParentState({
                    roles: [...roles, c_data.abilities.find((d) => d.id === +val)],
                });
            }
            if (+val === 0) {
                this._updateCrewCanvasser({ roles: [] });
                this._updateParentState({
                    roles: [..._get(this.props, 'seat.roles', []).filter((d) => d?.id === 1)],
                });
            }

            this.setState({ editingRoleValue: +val }, () => this.setState({ editingRole: false }));
        };

        const abilities = [];
        let isDriver = false;

        c_data.abilities.forEach((d) => {
            abilities.push(<AvailRoleToken role={d.name} key={d.id} />);
            if (d.name === 'Driver') isDriver = true;
        });

        return (
            <div className="canvasser-row-wrapper">
                <div className="canvasser-meta-grid">
                    <div className="meta-label">Name</div>
                    <div className="meta-value">
                        <div className="name-and-abilities">
              <span className="name-block">
                {c_data.firstname} {c_data.lastname}
                  <span className="slashline">{c_data.metrics}</span>
              </span>
                            <div className="abilities-block">{abilities}</div>
                        </div>
                    </div>

                    <div className="meta-label">Sites</div>
                    <div className="meta-value">{this.props.seat.sites.length}</div>

                    <div className="meta-label">Role</div>
                    <div className="meta-value">
                        {!this.state.editingRole && (
                            <span
                                className="edit-toggle"
                                onDoubleClick={() => this.setState({ editingRole: true })}
                            >
                {this.state.editingRoleValue ? (
                    (
                        _get(c_data, 'abilities', []).find(
                            (d) => d.id === +this.state.editingRoleValue
                        ) || { name: ' ' }
                    ).name
                ) : (
                    <span className="ghost">None</span>
                )}
              </span>
                        )}

                        {this.state.editingRole && (
                            <Input
                                type="select"
                                options={[
                                    { display: '- -', value: 0 },
                                    ...c_data.abilities
                                        .filter((d) => d.name !== 'Driver')
                                        .map((d) => ({ display: d.name, value: d.id })),
                                ]}
                                onChange={_updateCrewCanvasserRole}
                                onBlur={() => this.setState({ editingRole: false })}
                                value={this.state.editingRoleValue}
                            />
                        )}
                    </div>

                    <div className="meta-label">Goal</div>
                    <div className="meta-value">
                        {!this.state.editingGoal && (
                            <span
                                className="edit-toggle"
                                onDoubleClick={() =>
                                    this.setState({ editingGoal: true }, () => this.goalInputRef.current.focus())
                                }
                            >
                {this.state.editingGoalValue || <span className="ghost">--</span>}
              </span>
                        )}
                        {this.state.editingGoal && (
                            <input
                                className="edit-toggle"
                                type="number"
                                value={this.state.editingGoalValue}
                                onChange={(ev) => this.setState({ editingGoalValue: ev.target.value })}
                                onBlur={() => {
                                    this.setState({ editingGoal: false });
                                    this._updateSeat({ goal: this.state.editingGoalValue });
                                }}
                                ref={this.goalInputRef}
                            />
                        )}
                    </div>

                    {isDriver && (
                        <>
                            <div className="meta-label">Driver</div>
                            <div
                                className="meta-value edit-toggle"
                                onDoubleClick={() => {
                                    this.setState({
                                        editingIsDriverValue: !this.state.editingIsDriverValue,
                                    });
                                    this._updateCrewCanvasser({
                                        roles: [{ id: 1, delete: this.state.editingIsDriverValue ? 1 : 0 }],
                                    });

                                    if (!this.state.editingIsDriverValue) {
                                        this._updateParentState({
                                            roles: [..._get(this.props, 'seat.roles', []), { id: 1, name: 'Driver' }],
                                        });
                                    } else {
                                        this._updateParentState({
                                            roles: _get(this.props, 'seat.roles', []).filter((d) => d.id !== 1),
                                        });
                                    }
                                }}
                            >
                                {this.state.editingIsDriverValue ? 'Yes' : <span className="ghost">No</span>}
                            </div>
                        </>
                    )}

                    <div className="meta-label">Comments</div>
                    <div className="meta-value">
                        {!this.state.editingComments && (
                            <span
                                className="edit-toggle"
                                onDoubleClick={() =>
                                    this.setState({ editingComments: true }, () =>
                                        this.commentsInputRef.current.focus()
                                    )
                                }
                            >
                {this.state.editingCommentsValue || <span className="ghost">None</span>}
              </span>
                        )}

                        {this.state.editingComments && (
                            <input
                                className="edit-toggle"
                                type="text"
                                value={this.state.editingCommentsValue}
                                onChange={(ev) => this.setState({ editingCommentsValue: ev.target.value })}
                                onBlur={() => {
                                    this.setState({ editingComments: false });
                                    this._updateSeat({ comments: this.state.editingCommentsValue });
                                }}
                                ref={this.commentsInputRef}
                            />
                        )}
                    </div>
                </div>

                <div className="action-column">
                    <button
                        className="button button-outline"
                        onClick={() =>
                            this.props.onCanvasserSelect(
                                canvasser_id,
                                this.props.seat.routeseat_id,
                                this.props.seat.crewcanvasser_id,
                                true
                            )
                        }
                    >
                        Unassign
                    </button>
                </div>
            </div>
        );
    };

    generateUnnassignedDataLine = () => {
        return (
            <div className="canvasser-meta-grid">
                <div className="meta-row full-width">
                    <div className="meta-label">Seat</div>
                    <div className="meta-value">Unassigned: {this.props.seat.sites.length} sites</div>
                </div>

                <div className="meta-row full-width">
                    <div className="meta-label">Assignment Note</div>
                    <div className="meta-value">
                        {!this.state.editingAssignmentPlaceholder && (
                            <span
                                className="edit-toggle"
                                onDoubleClick={() =>
                                    this.setState({ editingAssignmentPlaceholder: true }, () =>
                                        this.commentsInputRef.current.focus()
                                    )
                                }
                            >
                {this.state.assignmentPlaceholderValue &&
                this.state.assignmentPlaceholderValue.length ? (
                    <span className="primary-text">{this.state.assignmentPlaceholderValue}</span>
                ) : (
                    <span className="ghost">Add a note about how to assign this seat.</span>
                )}
              </span>
                        )}

                        {this.state.editingAssignmentPlaceholder && (
                            <input
                                className={'edit-toggle'}
                                type="text"
                                value={this.state.assignmentPlaceholderValue || ''}
                                onChange={(ev) =>
                                    this.setState({
                                        assignmentPlaceholderValue: ev.target.value.length ? ev.target.value : null,
                                    })
                                }
                                onBlur={() => {
                                    this.setState({ editingAssignmentPlaceholder: false });
                                    this._setAssignmentNote({
                                        note: this.state.assignmentPlaceholderValue,
                                        routeseat: this.props.seat.routeseat_id,
                                        shift: this.props.sr_data.shift,
                                    });
                                }}
                                ref={this.commentsInputRef}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div
                className="crew-seat"
                key={this.props.draggableId + '-' + this.props.seat.routeseat_id}
                style={{ borderColor: this.props.color }}
            >
                <div className="seat-indicator" style={{ backgroundColor: this.props.color }}>
                    Seat {this.props.seatIndex}
                </div>
                <Droppable
                    droppableId={
                        'routeseat-assign_' + this.props.seat.routeseat_id + '_crew_' + this.props.crew_id
                    }
                >
                    {(provided, snapshot) => (
                        <div ref={provided.innerRef} className={snapshot.isDraggingOver ? 'primary light' : ''}>
                            <div className="inputWrapper seat-two-column">
                                <div className="seat-col-left">
                                    {this.props.displaySites && (
                                        <div className="seat-site-list">
                                            {_get(this.props, 'seat.sites', []).map((s, i) => (
                                                <div
                                                    className="seat-site"
                                                    key={
                                                        'seat-site-list' +
                                                        this.props.draggableId +
                                                        this.props.seat.routeseat_id +
                                                        i
                                                    }
                                                    style={{ borderColor: this.props.color }}
                                                >
                                                    <div className="site-name" style={{ color: this.props.color }}>
                                                        {s.site_name}
                                                    </div>
                                                    <div className="site-address">
                                                        {s.addressline1}, {s.city}, {s.statecode}, {s.zip5}
                                                    </div>
                                                    <div
                                                        className="notes-in-table"
                                                        onClick={() =>
                                                            this.props.setSiteNoteModalSite({
                                                                ...s,
                                                                name: s.site_name,
                                                                id: s.site_id,
                                                            })
                                                        }
                                                    >
                                                        <NoteTagList addButton notes={s.notes} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="seat-col-right">
                                    {!!this.props.seat.canvasser_id
                                        ? this.generateCanvasserDataLine(this.props.seat.canvasser_id)
                                        : this.generateUnnassignedDataLine()}
                                </div>
                            </div>

                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}

class DraggableSiteRouteCrewClass extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: true,
            showTransportConfig: false,
            transportType: props.crewData?.transport_type || 'Driver',
            showUberModal: false,
            isUberAllowed: false,
            checkingUberAllowed: true,
            uberRide: {
                scheduleType: 'flexible',
                primaryRider: null,
                seats: [],
                pickupTime: '',
                pickupLocationType: '',
                pickupCustomAddress: '',
                dropoffLocationType: '',
                dropoffCustomAddress: '',
                stops: [],
            },
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.crewData?.transport_type !== prevProps.crewData?.transport_type) {
            this.setState({
                transportType: this.props.crewData?.transport_type || 'Driver',
            });
        }
    }

    async componentDidMount() {
        await this.checkUberAvailability();
    }

    checkUberAvailability = async () => {
        const { campaign_id, sitecanvass, doorcanvass_id } = this.props;
        this.setState({ checkingUberAllowed: true });
        const isAllowed = await allowUber({
            campaign_id,
            sitecanvass_id: sitecanvass,
            doorcanvass_id: this?.props?.doorcanvass_id,
        });

        this.setState({
            isUberAllowed: isAllowed,
            checkingUberAllowed: false
        });
    };

    handleBeforeSRDrag = () => {
        const dropMat = document.getElementById('crew-drop-mat');
        const crewList = document.getElementById('crewlist');

        if (dropMat) dropMat.className = 'crew-drop-mat active';
        if (crewList) crewList.className = 'crewlist inactive';
    };

    _renderSitesData(sites) {
        if (this.props.availableRoute) {
            return this.sites.length;
        }
    }

    toggleTransportPanel = () => {
        const willBeShown = !this.state.showTransportConfig;
        this.setState({ showTransportConfig: willBeShown });
        if (willBeShown) {
            this.props.reloadRides();
        }
    };

    _getCanvasserOptions = () => {
        let options = (this.props.canvassers || []).map((d) => ({
            display: d.firstname + ' ' + d.lastname,
            value: d.id,
        }));

        options.unshift({ display: '', value: 0 });
        return options;
    };

    _renderRouteSeats(crew_id) {
        if (!this.props.routeseats) return null;

        let sortedSeats = this.props.routeseats.slice().sort((a, b) => a.routeseat_id - b.routeseat_id);
        let driver = sortedSeats[sortedSeats.length - 1];

        return sortedSeats.map((item, index) => (
            <RouteSeatAssigment
                {...this.props}
                seat={item}
                seatIndex={index + 1}
                key={item.routeseat_id}
                first={index === 0}
                driver={item === driver}
                color={this.props.color}
                refreshUberRides={this.props.reloadRides}
            />
        ));
    }

    renderUberModal() {
        return (
            <UberSiteCrewModal
                show={this.state.showUberModal}
                uberRide={this.state.uberRide}
                routeseats={this.props.routeseats}
                office={this.props.office}
                seatCount={this.props.seatCount}
                saving={this.state.savingRide}
                onUpdate={(changes) => this.setState({ uberRide: { ...this.state.uberRide, ...changes } })}
                onClose={() => this.setState({ showUberModal: false })}
                onSave={() => this._saveUberRide()}
                onCancel={() => this.setState({ showUberModal: false, uberRide: this.getEmptyUberRide() })}
            />
        );
    }

    _renderTransportPanel() {
        const { transportType, isUberAllowed, checkingUberAllowed } = this.state;
        const { uberRides, loadingAllRides, loadingRideIds, cancelRide, submitRide, infoModal, fetchRideInfo, closeRideInfo } = this.props;

        const transportOptions = [
            { display: 'Driver', value: 'driver' }
        ];

        if (isUberAllowed) {
            transportOptions.push({ display: 'Uber', value: 'uber' });
        }
        return (
            <div
                className="transport-panel"
                style={{
                    padding: '12px',
                    background: '#fafafa',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    marginTop: '10px',
                }}
            >
                <h5 style={{ marginTop: 0 }}>Crew Transport</h5>

                <div style={{ display: 'block' }}>
                    <div>
                        <div style={{ marginBottom: '10px' }}>
                            <label className="meta-label">Transport Type</label>

                            <div style={{ maxWidth: '200px' }}>
                                {checkingUberAllowed ? (
                                    <div>Loading options...</div>
                                ) : (
                                    <Input
                                        type="select"
                                        value={transportType}
                                        options={transportOptions}
                                        onChange={this._onTransportTypeChange}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    {transportType === 'uber' && isUberAllowed && (
                        <div className="uber-rides-section" style={{ position: 'relative' }}>
                            <h4>Uber Rides</h4>

                            {loadingAllRides && (
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10,
                                }}>
                                    <i className="fa fa-spinner fa-spin" style={{ fontSize: '32px', color: '#666' }}></i>
                                </div>
                            )}

                            <UberRideTable
                                rides={uberRides}
                                loadingRideIds={loadingRideIds}
                                onCancelRide={cancelRide}
                                onSubmitToUber={submitRide}
                                infoModal={infoModal}
                                onFetchRideInfo={fetchRideInfo}
                                onCloseRideInfo={closeRideInfo}
                            />

                            <button
                                className="button"
                                onClick={() =>
                                    this.setState({
                                        showUberModal: true,
                                        uberRide: this.getEmptyUberRide(),
                                    })
                                }
                            >
                                + New Uber Ride
                            </button>
                        </div>
                    )}
                </div>

                {this.renderUberModal()}
            </div>
        );
    }

    _saveUberRide = async () => {
        const { uberRide } = this.state;
        const { crew_id, sitecanvass, sr_data, office } = this.props;

        const getGeocode = (addressDataObject) => {
            if (!addressDataObject) return { latitude: null, longitude: null };

            return {
                latitude: addressDataObject.latitude || null,
                longitude: addressDataObject.longitude || null,
            };
        };

        this.setState({ savingRide: true });
        const decode = (str) => {
            if (!str) return null;
            try {
                return JSON.parse(str);
            } catch {
                return null;
            }
        };

        const pickupObj = decode(uberRide.pickupLocationType);
        const dropoffObj = decode(uberRide.dropoffLocationType);

        const pickupGeocode = getGeocode(uberRide.pickupAddressData);
        const dropoffGeocode = getGeocode(uberRide.dropoffAddressData);

        const pickup_payload = pickupObj
            ? {
                type: pickupObj.type,
                office_id: pickupObj.type === 'office' ? office : null,
                site_id: pickupObj.type === 'site' ? pickupObj.site_id : null,
                display_name: pickupObj.type === 'address' ? uberRide.pickupCustomAddress || '' : null,
                custom_address: pickupObj.type === 'address' ? uberRide.pickupCustomAddress || '' : null,
                latitude: pickupObj.type === 'address' ? pickupGeocode.latitude : null,
                longitude: pickupObj.type === 'address' ? pickupGeocode.longitude : null,
                access_point_id: pickupObj.type === 'address' && uberRide.pickupAccessPoint ? uberRide.pickupAccessPoint.id : null,
                secondary_display_name: pickupObj.type === 'address' && uberRide.pickupAccessPoint ? uberRide.pickupAccessPoint.label : null,
                secondary_latitude: pickupObj.type === 'address' && uberRide.pickupAccessPoint ? uberRide.pickupAccessPoint.latitude : null,
                secondary_longitude: pickupObj.type === 'address' && uberRide.pickupAccessPoint ? uberRide.pickupAccessPoint.longitude : null,
                access_point_wayfinding_note: pickupObj.type === 'address' && uberRide.pickupAccessPoint ? uberRide.pickupAccessPoint.rider_wayfinding_note : null,
            }
            : null;

        const dropoff_payload = dropoffObj
            ? {
                type: dropoffObj.type,
                office_id: dropoffObj.type === 'office' ? office : null,
                site_id: dropoffObj.type === 'site' ? dropoffObj.site_id : null,
                custom_address: dropoffObj.type === 'address' ? uberRide.dropoffCustomAddress || '' : null,
                latitude: dropoffObj.type === 'address' ? dropoffGeocode.latitude : null,
                longitude: dropoffObj.type === 'address' ? dropoffGeocode.longitude : null,
                access_point_id: dropoffObj.type === 'address' && uberRide.dropoffAccessPoint ? uberRide.dropoffAccessPoint.id : null,
                access_point_label: dropoffObj.type === 'address' && uberRide.dropoffAccessPoint ? uberRide.dropoffAccessPoint.label : null,
                access_point_latitude: dropoffObj.type === 'address' && uberRide.dropoffAccessPoint ? uberRide.dropoffAccessPoint.latitude : null,
                access_point_longitude: dropoffObj.type === 'address' && uberRide.dropoffAccessPoint ? uberRide.dropoffAccessPoint.longitude : null,
                access_point_wayfinding_note: dropoffObj.type === 'address' && uberRide.dropoffAccessPoint ? uberRide.dropoffAccessPoint.rider_wayfinding_note : null,
            }
            : null;

        const stops = (uberRide.stops || []).map((stop, index) => {
            const obj = decode(stop.locationType) || {};
            const stopGeocode = getGeocode(stop.customAddressData);

            return {
                ordinal_position: index + 1,
                uberlocation: {
                    type: obj.type || null,
                    site_id: obj.type === 'site' ? obj.site_id : null,
                    office_id: obj.type === 'office' ? office : null,
                    custom_address: obj.type === 'address' ? stop.customAddress || '' : null,
                    latitude: obj.type === 'address' ? stopGeocode.latitude : null,
                    longitude: obj.type === 'address' ? stopGeocode.longitude : null,
                    access_point_id: obj.type === 'address' && stop.accessPoint ? stop.accessPoint.id : null,
                    access_point_label: obj.type === 'address' && stop.accessPoint ? stop.accessPoint.label : null,
                    access_point_latitude: obj.type === 'address' && stop.accessPoint ? stop.accessPoint.latitude : null,
                    access_point_longitude: obj.type === 'address' && stop.accessPoint ? stop.accessPoint.longitude : null,
                    access_point_wayfinding_note: obj.type === 'address' && stop.accessPoint ? stop.accessPoint.rider_wayfinding_note : null,
                },
            };
        });

        const pickup_date = this.props.crewData?.canvass_date || null;

        const riders_payload = (uberRide.seats || []).map((seat) => ({
            seat_number: seat,
            is_primary_rider: seat === uberRide.primaryRider,
            canvasser_id: null,
        }));

        if ((uberRide.seats || []).length) {
            const primaryCount = riders_payload.filter((r) => r.is_primary_rider).length;
            if (primaryCount !== 1) {
                alert('Please select exactly one primary rider seat.');
                return;
            }
        }

        const orderedRouteSeats = (this.props.routeseats || [])
            .slice()
            .sort((a, b) => a.routeseat_id - b.routeseat_id);

        const crewSeats = (uberRide.seats || []).map((seatNum) => {
            const rs = orderedRouteSeats[seatNum - 1];

            if (!rs) {
                throw new Error(
                    `No RouteSeat found for UI seat ${seatNum}. ` +
                    `Available routeseats: ${orderedRouteSeats.map((r) => r.routeseat_id).join(', ')}`
                );
            }

            return {
                seat_number: seatNum,
                routeseat_id: rs.routeseat_id,
            };
        });

        const crew_data = {
            sitecanvass: sitecanvass,
            siteroute: sr_data?.siteroute_id,
            crew: crew_id,
            seats: crewSeats,
        };

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const todayLocalDate = `${year}-${month}-${day}`;

        const payload = {
            requesttypecode: 'S',

            crew_id: crew_id,
            sitecanvass_id: sitecanvass,
            siteroute_id: sr_data?.siteroute_id,
            campaign_id: this.props.campaign_id || 1,

            schedule_type: uberRide.scheduleType,
            pickup_time: uberRide.scheduleType === 'scheduled' ? uberRide.pickupTime : null,
            pickup_date: pickup_date || todayLocalDate,

            primary_rider: uberRide.primaryRider,
            seats: uberRide.seats,
            riders: riders_payload,

            pickup: pickup_payload,
            dropoff: dropoff_payload,
            stops: stops,

            crew_data: crew_data,
            is_flexible_pickup: uberRide.scheduleType === 'flexible',
            is_ondemand_ride: uberRide.scheduleType === 'ondemand',
            is_scheduled_ride: uberRide.scheduleType === 'scheduled',

            status: 'approved',
        };

        try {
            const response = await api.post('/uber/ride-requests/', payload);
            console.log('Ride saved successfully', response.data);

            await this.props.reloadRides();

            this.setState({
                showUberModal: false,
                uberRide: this.getEmptyUberRide(),
                savingRide: false,
            });
        } catch (err) {
            console.log(err)
            alert(err.response?.data?.non_field_errors?.[0] ?? 'An error occurred');
        } finally {
            this.setState({ savingRide: false });
        }
    };

    getEmptyUberRide() {
        const pickup_date = this.props.crewData?.canvass_date || null;

        return {
            scheduleType: 'ondemand',
            primaryRider: null,
            seats: [],
            pickupTime: '',
            pickupLocationType: '',
            pickupCustomAddress: '',
            dropoffLocationType: '',
            dropoffCustomAddress: '',
            stops: [],
            pickup_date: pickup_date,
        };
    }

    _onTransportTypeChange = async (val) => {
        const { crew_id } = this.props;

        this.setState({ transportType: val });

        try {
            await api.patch(`/crews/${crew_id}/`, {
                transport_type: val,
            });
        } catch (err) {
            console.error('Failed to update crew transport type', err);
            alert('Failed to save transport type');
        }
    };

    _generateIncludedRoles() {
        let roles = this.props.routeseats.reduce((agg, d) => agg.concat(d.roles), []);

        roles = roles
            .sort((a, b) => a.id - b.id)
            .filter((d) => d?.id)
            .map((role, i) => <AvailRoleToken role={(role || {}).name} key={i} />);

        return <span className="crew-role-tokens">{roles}</span>;
    }

    _generateRouteToAllSitesToggle = () => {
        if (!this.props.routeseats) return null;

        let shouldDisplay = false;

        if (this.props.routeseats.length === 1) shouldDisplay = true;
        else if (
            _get(this.props, 'routeseats[0].sites', []).length &&
            ![...this.props.routeseats.slice(1)].some((d) => d.sites.length)
        )
            shouldDisplay = true;

        if (!shouldDisplay) return null;

        return (
            <div className="crew-subtitle" style={{ color: _get(this.props, 'sr_data.hex_color') }}>
                <Input
                    type="checkbox"
                    title="Smart Order and Route to All Sites"
                    onChange={this.props.onRouteToAllSitesToggle}
                    checked={this.props.sr_data.route_to_all_sites}
                />
            </div>
        );
    };

    _renderAvailableSiteRoute(provided, snapshot) {
        return (
            <div
                className="schedule-sr-card"
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...{
                    ...provided.dragHandleProps,
                    onMouseDown: () => this.handleBeforeSRDrag(),
                    onMouseUp: () => {
                        const dropMat = document.getElementById('crew-drop-mat');
                        const crewList = document.getElementById('crewlist');
                        if (dropMat) dropMat.className = 'crew-drop-mat testing';
                        if (crewList) crewList.className = 'crewlist';
                    },
                    onContextMenu: () => {
                        const dropMat = document.getElementById('crew-drop-mat');
                        const crewList = document.getElementById('crewlist');
                        if (dropMat) dropMat.className = 'crew-drop-mat';
                        if (crewList) crewList.className = 'crewlist';
                    },
                }}
            >
                <div
                    className="available-route"
                    style={{
                        borderLeftColor: this.props.color,
                        color: this.props.color,
                    }}
                    id={this.props.id}
                >
                    <div className="obj-title">{this.props.name}</div>
                    <div className="obj-data">{(this.props.routeseats || []).length} seats</div>
                </div>
            </div>
        );
    }

    _renderCrewCard(provided, snapshot) {
        let innerCard = (
            <>
                <div
                    className="crew-card-header"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <div
                        className="crew-card-header-left"
                        style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                    >
                        {this.state.isExpanded ? (
                            <i
                                className="remove-crew-icon fa fa-angle-down"
                                onClick={() => this.setState({ isExpanded: false })}
                                style={{ cursor: 'pointer' }}
                            />
                        ) : (
                            <i
                                className="remove-crew-icon fa fa-chevron-right"
                                onClick={() => this.setState({ isExpanded: true })}
                                style={{ cursor: 'pointer' }}
                            />
                        )}

                        <div className="crew-title" style={{ color: this.props.color }}>
                            {this.props.name} {this._generateIncludedRoles()}{' '}
                            {this._generateRouteToAllSitesToggle()}
                        </div>
                    </div>

                    <div className="crew-card-top-icons-right" style={{ display: 'flex', gap: '10px' }}>
                        <i
                            className="remove-crew-icon fas fa-car"
                            onClick={this.toggleTransportPanel}
                            style={{ cursor: 'pointer', marginRight: '4px' }}
                        />

                        <i
                            className="remove-crew-icon far fa-edit"
                            onClick={() =>
                                window.open(
                                    `/sitecanvass/${this.props.sitecanvass}/quickedit/?siteroute=${this.props.sr_data.siteroute_id}`,
                                    '_blank'
                                )
                            }
                            style={{ cursor: 'pointer' }}
                        />

                        <i
                            className="remove-crew-icon far fa-times-circle"
                            onClick={this.props.onDeleteClick}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </div>

                {this.state.isExpanded && (
                    <div className="seat-wrapper">
                        {this.state.showTransportConfig
                            ? this._renderTransportPanel()
                            : this._renderRouteSeats()}
                    </div>
                )}
            </>
        );

        if (provided && snapshot) {
            return (
                <div
                    className="assign-crew-card"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    {innerCard}
                </div>
            );
        }

        return <div className="assign-crew-card">{innerCard}</div>;
    }

    render() {
        let { draggableId, cardInDraggableContext } = this.props;

        return cardInDraggableContext !== false ? (
            <Draggable
                draggableId={draggableId}
                index={this.props.index}
                key={this.props.draggableId + this.props.index}
            >
                {(provided, snapshot) => (
                    <>
                        {this.props.availableRoute && this._renderAvailableSiteRoute(provided, snapshot)}
                        {!this.props.availableRoute && this._renderCrewCard(provided, snapshot)}
                    </>
                )}
            </Draggable>
        ) : (
            this._renderCrewCard()
        );
    }
}

function DraggableSiteRouteCrew(props) {
    const { crew_id, crewData } = props;
    const crewId = (crewData && crewData.id) || crew_id;

    const {
        uberRides,
        loadingAllRides,
        loadingRideIds,
        loadingRides,
        cancelRide,
        submitRide,
        reloadRides,
        submitError,
        clearSubmitError,
        infoModal,
        fetchRideInfo,
        closeRideInfo,
    } = useUberRides(crewId);

    return (
        <>
            <DraggableSiteRouteCrewClass
                {...props}
                uberRides={uberRides}
                loadingRides={loadingRides}
                loadingAllRides={loadingAllRides}
                loadingRideIds={loadingRideIds}
                cancelRide={cancelRide}
                submitRide={submitRide}
                reloadRides={reloadRides}
                infoModal={infoModal}
                fetchRideInfo={fetchRideInfo}
                closeRideInfo={closeRideInfo}
            />
            <UberSubmitErrorModal
                show={!!submitError}
                errorMessage={submitError}
                onClose={clearSubmitError}
            />
            <UberRideInfoModal
                show={infoModal?.show}
                rideInfo={infoModal?.data}
                loading={infoModal?.loading}
                onClose={closeRideInfo}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    canvassers: state.canvassers.data,
    campaign_id: state.session.focusedCampaign?.id,
});

const mapDispatchToProps = (dispatch) => ({
    setSiteNoteModalSite: (site) => dispatch(setSessionVar('siteNoteModalSite', site)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    DraggableSiteRouteCrew
);